import { AssetType } from '@innovyze/lib_am_common';
import { getAssetLocation } from '@innovyze/lib_am_common/Actions';
import { makeMapURL } from '@innovyze/lib_am_common/Utils';
import { MenuListButton, useGlobalization } from '@innovyze/stylovyze';
import { Map } from '@mui/icons-material';
import { useDispatch } from 'react-redux';
import { useRiskDetailsSelectors } from '../useRiskDetailsSelectors';
import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';

interface MenuCellProps {
	assetId: string;
	assetType: string;
}

export const MenuCell = ({ assetId, assetType }: MenuCellProps) => {
	const { t } = useGlobalization();
	const dispatch = useDispatch();
	const history = useHistory();

	const { setFindAsset, findAsset, assetLocation } =
		useRiskDetailsSelectors();

	useEffect(() => {
		if (
			findAsset &&
			assetLocation &&
			assetLocation.assetId === findAsset.assetId
		) {
			const url = makeMapURL(
				findAsset.assetType,
				findAsset.assetId,
				assetLocation.position,
			);

			if (url) history.push(url);

			setFindAsset(undefined);
		}
	}, [assetLocation, findAsset]);

	return (
		<div key={'findAsset'} role="menu" tabIndex={0}>
			<MenuListButton
				menuItems={[
					{
						text: t('Find Asset in Network'),
						icon: <Map />,
						onClick: () => {
							const mapAsset = {
								assetId,
								assetType: assetType as AssetType,
							};
							setFindAsset(mapAsset);

							dispatch(getAssetLocation(mapAsset));
						},
					},
				]}
				buttonCy="actions"
			/>
		</div>
	);
};
